import Immutable from "immutable";
import { floatToMoney } from "lib/money";

import { isCashless } from "state/school_money/entities/DinnerBooking";
import { staticOptions } from "state/school_money/entities/DinnerBooking/DinnerItem";

export const BookedOption = new Immutable.Record({
  id: "",
  name: "",
  price: 0,
  allergyInformation: ""
}, "Booked Dinner Option");

function buildBookedOptionFromAppserver(rawDinnerBooking, rawBookedOption, isFSMEligible) {
  const allergyInformation = rawDinnerBooking.dinner_items.map(dinnerItem => {
      if((dinnerItem.dinner_item_fk === rawBookedOption.item.id) || (dinnerItem.dinner_item_fk === rawBookedOption.status)){
        return dinnerItem.allergy_information
      } else {
        return undefined;
      }
    }
  );

  if (isCashless(rawDinnerBooking)) {
    const hasSelection = (rawBookedOption.status === "MEAL" || rawBookedOption.status === "SANDWICH");
    if (!hasSelection) {
      return BookedOption();
    }
    return BookedOption({
      id: rawBookedOption.item.id,
      name: rawBookedOption.item.name,
      price: floatToMoney(rawBookedOption.item.price),
      allergyInformation
    });
  } else {
    const { name, isFree } = staticOptions[rawBookedOption.status];
    return BookedOption({
      id: rawBookedOption.status,
      name,
      price: isFree || isFSMEligible ? 0 : floatToMoney(rawDinnerBooking.cost_per_dinner),
      allergyInformation
    });
  }

}

BookedOption.fromAppserver = buildBookedOptionFromAppserver;
export default BookedOption;



// WEBPACK FOOTER //
// ./src/state/school_money/entities/DinnerBooking/BookedOption.js